import { useState } from "react";
import { Download, Maximize2, Minimize2 } from "lucide-react";
import { mediaUrl } from "@/lib/api";

const ReaderToolbar = ({ magazine, pdf, full, onToggle }) => (
  <div className={`flex items-center justify-between gap-3 px-4 py-3 ${full ? "bg-[#111827] text-white" : "bg-white border border-b-0 border-zinc-200"}`}>
    <div className="min-w-0">
      <div className="font-heading font-extrabold truncate">{magazine.title} — {magazine.edition}</div>
      {!full && <p className="text-xs text-zinc-500 truncate">{magazine.description}</p>}
    </div>
    <div className="flex gap-2 shrink-0">
      <a data-testid="magazine-download-btn" href={pdf} download target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 h-9 px-3 bg-red-600 text-white text-xs font-bold uppercase tracking-wider hover:bg-red-700 transition-colors"><Download size={14} /> PDF</a>
      <button data-testid="magazine-fullscreen-btn" onClick={onToggle} className={`inline-flex items-center gap-1.5 h-9 px-3 text-xs font-bold uppercase tracking-wider border transition-colors ${full ? "border-zinc-600 hover:bg-white/10" : "border-[#111827] hover:bg-[#111827] hover:text-white"}`}>
        {full ? <><Minimize2 size={14} /> Fermer</> : <><Maximize2 size={14} /> Plein écran</>}
      </button>
    </div>
  </div>
);

export const MagazineReader = ({ magazine }) => {
  const [full, setFull] = useState(false);
  const pdf = mediaUrl(magazine.pdf_url);
  return (
    <div className={full ? "fixed inset-0 z-50 bg-black flex flex-col" : ""}>
      <ReaderToolbar magazine={magazine} pdf={pdf} full={full} onToggle={() => setFull((f) => !f)} />
      {pdf
        ? <iframe data-testid="magazine-pdf-reader" title="Liseuse" src={`${pdf}#view=FitH`} className={`w-full bg-zinc-700 ${full ? "flex-1" : "h-[75vh] border border-zinc-200"}`} />
        : <div data-testid="magazine-pdf-missing" className="h-64 bg-white border flex items-center justify-center text-zinc-500 text-sm">PDF indisponible pour cette édition.</div>}
    </div>
  );
};
